import React from 'react';
import './articlesview.css';
import { articles } from '../../data/data';


function ArticlesView() {
  return (
        <section id="why-choose-1821">
            <div class="cs-container">
                <div class="cs-content">
                    <picture class="cs-picture">
                        <source media="(max-width: 600px)" srcset="/images/articles/ssscmkearticles.jpeg"></source>
                        <source media="(min-width: 601px)" srcset="/images/articles/ssscmkearticles.jpeg"></source>
                        <img loading="lazy" decoding="async" src="/images/articles/ssscmkearticles.jpeg" alt="body builder" width="562" height="568"></img>
                    </picture>
                </div>
                <ul class="cs-card-group">
                    {articles.map((article) => (
                        <li class="cs-item" key={article.id}>
                            {/* <img class="cs-icon" loading="lazy" decoding="async" src={article.icon} alt="icon" width="32" height="32"></img> */}
                            <div class="cs-item-wrapper">
                                <a class="cs-item-link" href={article.url} target="_blank" rel="noopener noreferrer">
                                <h3 class="cs-h3">
                                    {article.title}
                                </h3>
                                </a>
                                <p class="cs-item-text">
                                    {article.description}
                                </p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}

export default ArticlesView;
